import axios from 'axios';
import swal from 'sweetalert2';// import sweet alert

const perPage = 20;
const fireMessage = (title, text, icon) => {
    return swal.fire({
        title,
        text,
        icon,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed || result.value) { // value for older SweetAlert2
            window.location.href = '/';
        }
    });
};

const state = {
    accessToken: localStorage.getItem('access_token') || null,
    hospitalId: localStorage.getItem('access_token') || null,
    hospital: {},
    lock: false,
    uploadProgress: null,
    perPage: perPage,
    notifications: {},
    preferredMethod: localStorage.getItem('method') || null,
    lastFetch: 0
};

const getters = {
    isLoggedIn: state => state.accessToken !== null ? true : false,
    hospital: state => state.hospital,
    lock: state => state.hospital && (state.hospital.profile_lock == 'yes') ? true : false,
    locations: state => state.locations,
    notifications: state => state.notifications,
    getHospitalAccessToken: state => state.accessToken,
    getPreferredMethod: state => state.preferredMethod,
    shouldUpdate: (state) => {
        const lastFetch = state.lastFetch;
        if (!lastFetch) return true; // Always fetch if never fetched
        const fiveMinutes = 5 * 60 * 1000;
        return (Date.now() - lastFetch) > fiveMinutes;
    }
};

const actions = {
    async updateHospitalProfile({ state, getters, rootState, commit }, status = false) {// fetch profile only not cached 
        if (!getters.shouldUpdate && ! status) {
            console.log("Using cached products.");
            return state.hospital; // Exit early if the cache is still fresh
        }
        console.log("updating from server");
        try {
            const authorizationToken = rootState.user.accessToken;
            const url = rootState.url.hospitalProfileUrl;
            const header = {Authorization: `Bearer ${authorizationToken}`};
            const response = await axios.post(url, {}, { headers: header });// make api call
            commit('setHospital', response.data.hospital);
        return response.data.hospital;
        } catch (error) {
            fireMessage(
                "Session Expired!", 
                "Your session has expired please log in again to continue", 
                "warning"
            );
            localStorage.removeItem('access_token');// remove token
            localStorage.removeItem('time_out');// remove time out
            localStorage.removeItem('method');// remove time out
            state.accessToken = null;
            return setTimeout(() => { window.location.href = '/'; }, 5000);// redirect to login
        }
    },
    async fetchHospitalProfile(state) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.hospitalProfileUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, {}, { headers: header });// make api call
        state.commit('setHospital', response.data.hospital);
        return response.data.hospital;
    },
    async getHospitals(state) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getHospitalsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url,{}, { headers: header });// make api call
        return response.data;
    },
    async createSignup(state, data) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.createSignupUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    async hospitalLogin(state, data) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.hospitalLoginUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    storeAndLoginUser(state, data) {//set token and login user
        let hours = 2;
        localStorage.setItem('access_token', data.access_token);// set access token
        localStorage.setItem('method', data.preferred_method);// set access token
        localStorage.setItem('time_out', new Date().getTime() + (hours * 60 * 60 * 1000));// set timeout
    },
    destroyAccessToken(state) {// destroy local storage
        localStorage.removeItem('access_token');// remove token
        localStorage.removeItem('time_out');// remove time out
        localStorage.removeItem('method');// remove time out
        fireMessage(
            "Session Ended!", 
            "You have been logged out...", 
            "warning"
        );
        return setTimeout(() => { window.location.href = '/'; }, 5000);// redirect to login
    },
    async changePassword(state, data) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.changePasswordUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    async uploadUserPhoto(state, data) {// upload user documents
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.uploadUserPhotoUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, {
            headers: header,
            onUploadProgress: uploadEvent => {
                state.state.uploadProgress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
            }
        });// make api call
        return response.data;
    },
    updatePhotoName({ commit }, fileName) {// update photo name
        commit('setUpdatePhotoName', fileName);// set update photo function
    },
    async getHospitalNotifications(state, limit) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getHospitalNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : state.state.hospitalId, limit : limit }, { headers: header });// make api call
        state.commit('setHospitalNotifications', response.data);
        return response.data;
    },
    async getHospitalNotification(state, slug) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getHospitalNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { slug : slug }, { headers: header });// make api call
        return response.data;
    },
    async getHospitalLetters(state) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getHospitalLettersUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : state.state.hospitalId}, { headers: header });// make api call
        return response.data;
    },
    async deleteUserNotification(state, id) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getDeleteUserNotificationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : id }, { headers: header });// make api call
        return response.data;
    },
    async downloadAnyFile(state, data) {
        const authorizationToken = state.rootState.user.accessToken;
        try {
            const response = await axios.post( data.url, data,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${authorizationToken}`
                    },
                }
            );
            // trigger an actual file download (zip/archive), not just open in a tab
            const contentType = response.headers['content-type'] || data.contentType;
            const blobUrl = URL.createObjectURL(new Blob([response.data], { type: contentType }));

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = data.fileName; // adjust extension to match actual file type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);            
        } catch (error) {
            let errorMsg = data.msg;
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMsg = json.msg || json.message || text;
                } catch {
                    errorMsg = data.msg + ' ' + error.message;
                }
            } else {
                errorMsg = error.message || errorMsg;
            }
            swal.fire('Error!', error + ' - ' + errorMsg, 'error');
        }
        return false;
    }
};

const mutations = {
    setHospital: (state, hospital) => (state.hospital = hospital),// set user profile
    setUpdatePhotoName: (state, fileName) => (state.hospital.photo = fileName),// set user basic profile only
    setHospitalNotifications(state, data) {// set user notifications
        state.notifications.records = data.notifications.data;
        state.notifications.total = data.total;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}